import { cn } from '../../../../lib/utils';
import { ReactNode } from 'react';

export type FloatingActionButtonSize = 'default';

interface FloatingActionButtonProps extends React.ComponentProps<'button'> {
  /** 플로팅 액션 버튼 확장 여부 */
  extended?: boolean;
  /** 플로팅 액션 버튼 앞쪽 아이콘 */
  leadingNode?: React.ReactNode;
  /** 플로팅 액션 버튼 앞쪽 아이콘 클릭 이벤트 */
  leadingOnClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  /** 플로팅 액션 버튼 뒤쪽 아이콘 */
  trailingNode?: React.ReactNode;
  /** 플로팅 액션 버튼 뒤쪽 아이콘 클릭 이벤트 */
  trailingOnClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  /** 플로팅 액션 버튼 아이콘 or ReactNode */
  children?: React.ReactNode;
}

export default function FloatingActionButton({
  extended = false,
  leadingNode,
  leadingOnClick,
  trailingNode,
  trailingOnClick,
  children,
  ...props
}: FloatingActionButtonProps) {
  const { className, ...restProps } = props;

  return (
    <button
      className={cn(
        `flex h-[48px] cursor-pointer items-center justify-center gap-4xs rounded-full bg-comp-fab-bg-default p-md transition-all`,
        'hover:bg-comp-fab-bg-hover active:bg-comp-fab-bg-active',
        extended && 'max-w-[48px] min-w-[48px]',
        className,
      )}
      {...restProps}
    >
      {leadingNode && (
        <IconWrapper onClick={leadingOnClick}>{leadingNode}</IconWrapper>
      )}
      {children && (
        <div className="text-comp-fab-text-default">
          <div
            className={cn(
              'text-comp-accent-medium',
              '[&>svg>g>path]:fill-comp-fab-text-default',
            )}
          >
            {children}
          </div>
        </div>
      )}
      {trailingNode && (
        <IconWrapper onClick={trailingOnClick}>{trailingNode}</IconWrapper>
      )}
    </button>
  );
}

export const IconWrapper = ({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}) => {
  return (
    <div
      className={cn(
        'flex items-center justify-center [&>svg>g>path]:fill-comp-fab-text-default',
        '[&>svg]:min-h-[24px] [&>svg]:min-w-[24px]',
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
